import { createFileRoute, Outlet, useNavigate } from '@tanstack/react-router';
import { GroupsList } from '../app/components/group/groups-list';
import { ProtectedRoute } from '@org/ui';
import { useTranslation } from 'react-i18next';

export const Route = createFileRoute('/groups')({
  component: GroupsRoute,
});

function GroupsRoute() {
  const navigate = useNavigate({ from: '/groups' });
  const { t } = useTranslation('admin');

  return (
    <ProtectedRoute requiredPermissions={['admin:all', 'groups:*']}>
      <div className="space-y-6">
        <h1 className="text-2xl font-semibold tracking-tight">{t('sidebar.navigation.groups')}</h1>
        <GroupsList
          onCreateGroup={() => navigate({ to: '/groups/new' })}
          onEditGroup={(group) =>
            navigate({ to: '/groups/$groupId', params: { groupId: group.groupId } })
          }
        />
        <Outlet />
      </div>
    </ProtectedRoute>
  );
}


